<template>
  <section class="[ p-2 ]">
    <h1 class="[ text-xl font-bold ]">Help</h1>
  </section>
</template>

<script setup lang="ts">
definePage({
  meta: { title: "Help", icon: "help" },
});
</script>
